<template>
  <iframe id="frame" frameborder="0"></iframe>
</template>
<script>
export default {
  name: "Live",
  methods: {},
  mounted() {
    this.$nextTick(async () => {
      const {
        course_type,
        course_id,
        period_id,
        type,
        class_group_id,
        arrange_id,
      } = this.$route.query;

      let liveData;
      if (course_type == 1) {
        liveData = await this.$http.get(
          `/api/lector/teacher/getLiveRoomCode/${course_id}/0`,
          {},
          {
            onError: () => {
              this.$router.push({ name: "Home" });
            },
          },
        );
      } else {
        liveData = await this.$http.get(
          `/api/lector/teacher/entrance/${course_id}/${course_type}/${period_id}/${type}/${class_group_id}`,
          { arrange_id },
          {
            onError: () => {
              this.$router.push({ name: "Home" });
            },
          },
        );
      }
      let frame = document.getElementById("frame");
      frame.allow = "microphone;camera;midi;encrypted-media;";
      document.getElementById("frame").src = liveData.web_url;
    });
  },
};
</script>
<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 100vh;
  display: block;
}
</style>
